import ISvgProps from '../../../SvgLoader/ISvgProps';

function SvgTie(props: ISvgProps) {
	return (
		<svg width={56} height={56} fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M5 50.727C5 38.176 15.298 28 28 28s23 10.175 23 22.727C51 51.983 49.97 53 48.7 53c-1.27 0-2.3-1.017-2.3-2.273 0-10.041-8.238-18.181-18.4-18.181-10.162 0-18.4 8.14-18.4 18.181C9.6 51.983 8.57 53 7.3 53 6.03 53 5 51.983 5 50.727Z"
				fill={props.secondaryColor}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M27.5 7.545c-3.81 0-6.9 3.053-6.9 6.819 0 3.765 3.09 6.818 6.9 6.818 3.81 0 6.9-3.053 6.9-6.818 0-3.766-3.09-6.819-6.9-6.819ZM16 14.364C16 8.088 21.149 3 27.5 3S39 8.088 39 14.364c0 6.276-5.149 11.363-11.5 11.363S16 20.64 16 14.364ZM27.5 28c1.01 0 1.901.65 2.198 1.604l4.6 14.773c.224.719.073 1.5-.402 2.088l-4.6 5.682A2.31 2.31 0 0 1 27.5 53a2.31 2.31 0 0 1-1.796-.853l-4.6-5.682a2.252 2.252 0 0 1-.402-2.088l4.6-14.773A2.297 2.297 0 0 1 27.5 28Zm-2.044 16.565 2.044 2.524 2.044-2.524L27.5 38l-2.044 6.564Z"
				fill={props.primaryColor}
			/>
		</svg>
	);
}

export default SvgTie;
